import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Approve from "./tabs/approve";

export default function Infraction() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/admin/infractions/1`);

    // eslint-disable-next-line
  }, []);

  return (
    <div data-test="rewards-page">
      <div>
        <Approve />
      </div>
    </div>
  );
}
